import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from 'vue-property-decorator';
import gaussRound from '@/api/gaussRound';
import { SupervisorAnalyticsList } from '@/types/supervisor-analytics';
import REQ_URL from '@/consts/req-url';

@Component({
})
export default class SupervisorAnalyticsTable extends Vue {
    search = ''
    xlsLink = REQ_URL.DOWNLOAD_SUP_AN
    headers = [
        {
            text: 'Клиент',
            value: 'Клиент',
            sortable: true,
        },
        {
            text: 'Сегмент рынка',
            value: 'СегментРынка',
            sortable: true,
        },
        {
            text: 'Новый клиент',
            value: 'Новый',
            sortable: true,
        },
        {
            text: 'Отгр.',
            value: 'Отгр',
            sortable: true,
        },
        {
            text: 'Отгружено, руб',
            value: 'Отгружено',
            sortable: true,
        },
        {
            text: 'Себестоимость, руб',
            value: 'Себестоимость',
            sortable: true,
        },
        {
            text: 'Рентабельность продаж',
            value: 'Рентабельность',
            sortable: true,
            align: 'right'
        },
        {
            text: 'Позиций (артикулов)',
            value: 'КолАртикулов',
            sortable: true,
        },
        {
            text: 'Среднее кол-во SKU в ТТ',
            value: 'СреднееКолво',
            sortable: true,
        },
        {
            text: 'Возврат, руб',
            value: 'Возврат',
            sortable: true,
        },
        {
            text: 'Оплачено, руб',
            value: 'Оплачено',
            sortable: true,
        },
        {
            text: 'В т.ч. по банку, руб',
            value: 'Банк',
            sortable: true,
        },
        {
            text: 'В т.ч. по кассе, руб',
            value: 'Касса',
            sortable: true,
        },
        {
            text: 'Кон. баланс, руб',
            value: 'КонБаланс',
            sortable: true,
        },
        {
            text: 'Кон. баланс НАШ ДОЛГ, руб',
            value: 'КонБалансНашДолг',
            sortable: true,
        },
        {
            text: 'Дата',
            value: 'ДатаОтчета',
            sortable: false,
            align: 'center'
        }
    ];
    @Prop({ default: () => [] }) supervisorAnalyticsList!: SupervisorAnalyticsList
    @Prop({ default: true }) loading!: Boolean
    noResultsText = 'Нет результатов, удовлетворяющих параметрам поиска.'
    get noDataText() {
        return this.loading ? 'Идет поиск...' : this.noResultsText
    }
    format(num: number) {
        return num ? (new Intl.NumberFormat('ru', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        })).format(num) : ''
    }
    total(key: string) {
        return (new Intl.NumberFormat('ru', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        })).format(this.supervisorAnalyticsList.reduce((accumulator, debt) => {
            return gaussRound( accumulator + (debt as any)[key], 2 )
        }, 0))
    }
    mounted() { }
}